<template>
  <div class="relative">
    <div
      @mouseover="isTooltipTextVisible = true"
      @mouseleave="isTooltipTextVisible = false"
    >
      <slot name="icon" />
    </div>
    <div
      v-show="isTooltipTextVisible"
      class="absolute w-80 p-4 rounded-lg bg-white z-10 shadow-secondary"
    >
      <p class="tooltip-content">
        {{ props.tooltipText }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";

interface PropsI {
  tooltipText: string;
}

const props = defineProps<PropsI>();

const isTooltipTextVisible = ref<boolean>(false);
</script>
